import React, { Component } from 'react';
import PropTypes from 'prop-types';
import  '../../../containers/AdminConfig/css/AdminConfig.css';
import '../../../containers/AdminConfig/js/AdminConfig';
import EditPoi from '../../AdminConfig/Content/editPoi';
import ImportExportPoi from './ImportExportPoi';
import ListPoi from '../../AdminConfig/Content/listPoi';
import ModalConfirmEditPoi from '../../../Modals/ModalConfirmUserInformation';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import AlertBar from '../../../Modals/AlertBar';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';

class POIconfig extends Component {

    constructor() {
        super();

        this.state = {
            editPoiObj: {},
            isEditPoi: false,
            showModalConfirmEditPoi: false,
            poiObj: {},
            notification: false,
            isUpdate: false,
            showModalConfirmDeletePoi: false,
            openList : true,
            openAdd : false,
            openEdit: false,
        };

    }

    onClickRowListTable = (poiObj) => {
        this.setState({ isEditPoi: true, editPoiObj: poiObj,openList:false,openEdit:true });
    }

    onClickCancelEditPoi = () => {
        this.setState({ isEditPoi: false, showModalConfirmEditPoi: false });
    }

    onClickConfirmUserInformation = (poiObj) => {
        this.setState({ showModalConfirmEditPoi: false, poiObj });
        AlertConfirm("แก้ไข POI","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { poiObj, editPoiObj } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
                window.scrollTo(0, 0);
                // fetch(`http://api.fasttrack.co.th/updatePOI/${editPoiObj.id}`, {
                    fetch(`http://203.150.199.244/api/admin/updatePOI/${editPoiObj.id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "name" : poiObj.name || editPoiObj.name,
                        "group" : poiObj.group || editPoiObj.group,
                        "radius" : Number(poiObj.radius) || Number(editPoiObj.radius),
                        "location" : {
                            "latitude" : Number(poiObj.latitude) || Number(editPoiObj.lat),
                            "longitude" : Number(poiObj.longitude) || Number(editPoiObj.lng)
                        },
                        "icon" : {
                            "name" : poiObj.icon_name,
                            "color" : poiObj.icon_color,
                            "is_small" : false
                        },
                        "alert" : {
                            "email" : poiObj.email || editPoiObj.email,
                            "line_token" : poiObj.lineToken || editPoiObj.line_token,
                            "when" : {
                                "is_entry" : poiObj.isEntry,
                                "is_leave" : poiObj.isLeave
                            }
                        }
                    })
                })
                    .then(response => response.json())
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({ 
                            // showModalConfirmEditPoi: false, 
                            // notification: true, 
                            isEditPoi: false })
                    })
                    // .then(setTimeout(() => {
                    //     this.setState({ notification: false });
                    // }, 8000))
                    .then(() => {this.setState({
                        openList : true,
                        openEdit: false,})})
                    // .then(() => {window.location.reload(true);})
                    .then(() => {window.scroll(0, 0);})
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    onClickDeletePoi = (delPoiObj) => {
        this.setState({ showModalConfirmDeletePoi: false, poiObj: delPoiObj });

        AlertConfirm("ลบ POI","คุณต้องการลบ POI หรือไม่").then(isOk=>{
            if(isOk){
                // fetch(this.props.url.replace("getFlashViewList","deleteFlashView/")+ flash.flash_view_cd , {
                //     method: 'post',
                //     headers: {
                //         "Content-Type": "application/json; charset=utf-8",
        
                //         // "user_id":user_id,
                //         // "user_name":user_name,
                //         "token":token
                //         },
                //     body: JSON.stringify({})
                // }).then(function(response) {
                //     return checkStatus(response);
                // }).then(function(data) {
                //     console.log(data,"data")
                //     currentComponent.btnDelClose.click();
                //     currentComponent.getFlash(1,500);
                //     if(data.RESULT_STATUS == "000")
                //         AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                //     else{
                //         AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                //     }
                // });

                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
        
                const { poiObj } = this.state;
                fetch(`http://203.150.199.244/api/admin/deletePOI/${poiObj.id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({})
                })
                    .then(response => response.json())
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({ 
                            showModalConfirmDeletePoi: false, 
                            // notification: true, 
                            isEditPoi: false 
                        })
                    })
                    // .then(setTimeout(() => {
                    //     this.setState({ notification: false });
                    // }, 8000))
                    .then(() => {this.setState({isUpdate: true})})
                    // .then(() => {window.location.reload(true);})
                    .then(() => {window.scroll(0, 0);})
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
            
        });
    }

    onClickCancelDelete = () => {
        this.setState({ showModalConfirmDeletePoi: false })
    }

    onClickConfirmDelete = () => {
        const {
            user_name,
            user_id,
            token
        } = this.props;

        const { poiObj } = this.state;
        fetch(`http://203.150.199.244/api/admin/deletePOI/${poiObj.id}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then(() => {this.setState({ showModalConfirmDeletePoi: false, notification: true, isEditPoi: false })})
            .then(setTimeout(() => {
                this.setState({ notification: false });
            }, 8000))
            .then(() => {this.setState({isUpdate: true})})
            // .then(() => {window.location.reload(true);})
            .then(() => {window.scroll(0, 0);})
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onClickConfirmEditPoi = () => {

        AlertConfirm("แก้ไข POI","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { poiObj, editPoiObj } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
                console.log(poiObj)
                window.scrollTo(0, 0);
                // fetch(`http://api.fasttrack.co.th/updatePOI/${editPoiObj.id}`, {
                    fetch(`http://203.150.199.244/api/admin/updatePOI/${editPoiObj.id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "name" : poiObj.name || editPoiObj.name,
                        "group" : poiObj.group || editPoiObj.group,
                        "radius" : Number(poiObj.radius) || Number(editPoiObj.radius),
                        "location" : {
                            "latitude" : Number(poiObj.latitude) || Number(editPoiObj.lat),
                            "longitude" : Number(poiObj.longitude) || Number(editPoiObj.lng)
                        },
                        "icon" : {
                            "name" : poiObj.icon_name,
                            "color" : poiObj.icon_color,
                            "is_small" : false
                        },
                        "alert" : {
                            "email" : poiObj.email || editPoiObj.email,
                            "line_token" : poiObj.lineToken || editPoiObj.line_token,
                            "when" : {
                                "is_entry" : poiObj.isEntry,
                                "is_leave" : poiObj.isLeave
                            }
                        }
                    })
                })
                    .then(response => response.json())
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({ 
                            showModalConfirmEditPoi: false, 
                            // notification: true, 
                            isEditPoi: false })
                    })
                    // .then(setTimeout(() => {
                    //     this.setState({ notification: false });
                    // }, 8000))
                    .then(() => {this.setState({isUpdate: true})})
                    // .then(() => {window.location.reload(true);})
                    .then(() => {window.scroll(0, 0);})
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });

    }

    onClickCancelUserInformation = () => {
        this.setState({ showModalConfirmEditPoi: false });
    }

    onClickBack = () =>{
        this.setState({
            openList : true,
            openAdd : false,
            openEdit : false,
        });
    }

    onOpenAdd = () => {
        // this.setState({dataNewDriver: data}, () => this.onClickConfirmUserInformation());
        this.setState({
            openList : false,
            openAdd : true,
        });
    } 

    onOpenEdit = (driver) => {
        this.setState({
            openList : false,
            openEdit : true,
            dataUpdate:driver,
        });
    }

    activeList(){
        this.setState({isUpdate: true})
    }

    render() {
        const { editPoiObj, isEditPoi,
             showModalConfirmEditPoi, notification, isUpdate, showModalConfirmDeletePoi,
             openList,
             openAdd ,
             openEdit, } = this.state;
        if (isUpdate) {
            this.setState({isUpdate: false});
            return (<ListPoi onClickRowListTable={this.onClickRowListTable}  token={this.props.token} />)
        }
        console.log('isUpdate',isUpdate)
        return (
                <div className="gray-panel">
                    {
                        notification &&
                        <AlertBar />
                    }
                    
                    {/* <SideBarToggle /> */}
                    <div className="col-12">
                        <h1 className="page-header"> <i className="fa fa-map-marker" style={{color: '#7386D5'}} />จัดการข้อมูล POI</h1>
                    </div>
                    {/* <div> */}
                        
                            {/* Nav tabs */}
                            {
                                  openEdit &&
                                    <EditPoi
                                        editPoiObj={editPoiObj}
                                        onClickCancelEditPoi={this.onClickCancelEditPoi}
                                        onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                                        onClickDeletePoi={this.onClickDeletePoi}
                                        onBack={this.onClickBack}
                                    />
                                }
                            {openList &&
                                <div>

                            <nav>
                                <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                    <a className="nav-item nav-link active" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true" onClick={() => this.activeList()}>รายการ</a>
                                    <a className="nav-item nav-link" id="nav-import-tab" data-toggle="tab" href="#nav-import" role="tab" aria-controls="nav-import" aria-selected="false">นำเข้า/ส่งออก</a>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent" style={{marginTop:15}}>
                                
                                <div className="tab-pane fade show active" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
                               
                                <ListPoi
                                    onClickRowListTable={this.onClickRowListTable}
                                    onClickDeletePoi={this.onClickDeletePoi}
                                    onClickCancelEditPoi={this.onClickCancelEditPoi}
                                    onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                                    openEdit={this.onOpenEdit}
                                    onBack={this.onClickBack}
                                    token={this.props.token}
                                />
                               
                                { showModalConfirmEditPoi &&
                                    <ModalConfirmEditPoi
                                        onClickCancelUserInformation={this.onClickCancelUserInformation}
                                        onClickConfirmUserInformation={this.onClickConfirmEditPoi}
                                    />
                                }
                                { showModalConfirmDeletePoi  &&
                                    <ModalConfirmDelete
                                        onClickCancelDelete={this.onClickCancelDelete}
                                        onClickConfirmDelete={this.onClickConfirmDelete}
                                    />
                                }
                                </div>

                                

                                <div className="tab-pane fade" id="nav-import" role="tabpanel" aria-labelledby="nav-import-tab">
                                       <ImportExportPoi token={this.props.token}/>
                                </div>
                            </div>
                                </div>
                            }
                            
                        {/* </div> */}

                    </div>

            );
        }
    }

POIconfig.propTypes = {
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired
}


export default POIconfig;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/POIconfig.js